import React, { useState, useEffect } from "react";
import {
  Show,
  List,
  TabbedShowLayout,
  Tab,
  Datagrid,
  EditButton,
  TextField,
  ImageField,
  ReferenceField,
  ReferenceManyField,
  DateField,
  TopToolbar,
  RefreshButton,
  ListButton,
  BooleanField,
  EmailField,
  NumberField,
  useTranslate,
  useGetOne,
  useResourceContext,
  useRecordContext,
  DeleteButton,
  useListContext,
  Button,
  Link,
  Pagination,
} from "react-admin";
import { CamelCaseField, ExpectedDateField } from "../digitalOrders/common";
import {
  getLocalStorageKey,
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
  GetCurrentUserRoles,
} from "../common/common";
import { OrderStatus } from "../loyaltyWithReward/common";
import { useLocation } from "react-router-dom";



const ShowActions = () => {
  const userLocale = getLocalStorageKey("locale");
  const record = useRecordContext();
  console.log("record", record);
  const resource = useResourceContext();
  let roleData = GetCurrentUserRoles();
  console.log("roleData", roleData);

  return (
    <TopToolbar>
      <RefreshButton />
      <ListButton basePath={resource} />
      {
        (!record || record.is_clickit_user) ? null :
        <EditButton basePath={resource} record={record} id={record?.id} />
      }
    </TopToolbar>
  );
};

const ShowTitle = () => {
  const translate = useTranslate();
  const record = useRecordContext();
  return (
    record && (
      <span>
        {translate("resources.users.fields.user_test")} {record.first_name}
      </span>
    )
  );
};

const RoleName = (props) => {
  const record = useRecordContext();  
  return (
    <span>
      {/* {record?.role_name.replace(/_/g, " ")} */}
    </span>
  );
};

const UserSignUpShow = ({ permissions, ...props }) => {
  const record = useRecordContext();
  const location = useLocation();
  const translate = useTranslate();
  const pathSplit = location.pathname.split("/");
  const businessIdVal = pathSplit[2];
  console.log("props ==> userssss", businessIdVal);
  const { id } = props;
  const showAllOrders = getLocalStorageKey("show_all_orders");
  const userLocale = getLocalStorageKey("locale");

  const { data } = useGetOne("clickit_signup_customers", { id: businessIdVal });




  return (
    // <div>
    //   <text>hfghgjfjh</text>
    // </div>
    <Show actions={<ShowActions />} title={<ShowTitle />}>
      <TabbedShowLayout Class="tab-scroll">
        <Tab
          label={translate("resources.users.fields.user_details")}
          contentClassName="scrollTab"
        >
          <TextField source="first_name" />
          <TextField source="last_name" />
          <TextField source="business_name" />
          <TextField source="business_address" />
          <EmailField source="email" />
          <TextField source="mobile" />
          <ImageField source="profile_image_data" title="Profile Image" />
          {/* <BooleanField source="is_super" /> */}
          {/* <TextField source="role_name" /> */}
          {/* <RoleName label="Role name" source="role_description" /> */}
          {/* <BooleanField source="status" /> */}
          <BooleanField source="is_clickit_user" /> 

          <DateField source="updated_at" />
          <DateField source="created_at" />
        </Tab>

      </TabbedShowLayout>
    </Show>
  );
};

export default UserSignUpShow;
